export const noResultsDescription = 'No se encontraron resultados';
export const noResultsButton = 'Escanear QR';
